import type { LessonCheckSchedulePayload } from '../../model/lessons/interfaces'
import type { ApiResponse } from '@shared/api'

import { getAxiosErrorMessage } from '@shared/api'
import { useAdminRoutes } from '@shared/lib/routes'
import { useToast } from '@shared/ui/toast'

interface LessonCheckScheduleApiOptions {
  disciplineId: string | number
  payload: LessonCheckSchedulePayload
}

/** `POST /admin-api/disciplines/{discipline}/lessons/check-schedule` — whether the tutor works at that start. It does
 *  not say the tutor is free: that is the availability list. Null when the check itself failed. */
export const useLessonCheckScheduleApi = async (options: LessonCheckScheduleApiOptions): Promise<boolean | null> => {
  const { $axios } = useNuxtApp()
  const toast = useToast()

  const url = useAdminRoutes('admin.lessons.api.check-schedule', { discipline_id: options.disciplineId })

  try {
    if (!url) {
      toast.error('Unexpected error. Invalid request URL.')
      return null
    }

    const { data } = await $axios.post<ApiResponse>(url, options.payload)

    return !!data.data?.is_allowed
  } catch (err: unknown) {
    toast.error(getAxiosErrorMessage(err))

    return null
  }
}
